import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import HomeSlider from "../homeslider";
import PopularFlights from "../PopularFlights";

import AboutUs from "../AboutUs";
import Faqs from "../Faqs";
import Newsletter from "../Newsletter";
import PopularFlightsRoutes from "../PopularFlightsRoutes";
import PopularHotels from "../Hotels/Component/PopularHotels";
import BookTickets from "../BookTickets";
import FlightDestinations from "../FlightDestinations";
import PopularAirlines from "../PopularAirlines";
import FlightsFrom from "../FlightsFrom";
import FlightsWidgit from "../FlightsWidgit";
import CheapFlights from "../CheapFlights";
import Badge from "../Badge";

function App1() {
  return (
   <>

    <Helmet>     
<title>Us Airways, Lowest Airfare and offers | cheapflightsprices.com</title>
<meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
<meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,US airways, us airways reservation,us airways reservation"/>
<meta property="og:title" content="Us Airways, Lowest Airfare and offers | cheapflightsprices.com" />
<meta property="og:description" content="Find Us Airways Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Us Airways, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Us Airways, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<link rel="canonical" href="https://cheapflightsprices.com/airlines/.html" />
</Helmet>

   <section id="banner_section">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Cheap Flight Tickets</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
      
    </div>
  </section>
<Badge/>


    <main id="main">
    <PopularFlights/>
    <FlightDestinations/>
    <PopularAirlines/>
    <PopularFlightsRoutes />
    <PopularHotels />
    <FlightsFrom/>
    <section id="Cheapflights" className="section-with-bg">
    <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2><strong></strong></h2>
          <p></p>
        </div>
        <div className="designcontainer">
         
        </div>
      </div>
    </section>
    <Faqs/>
    <Newsletter/>
    
      </main>
  
    </>
  );
}
export default App1;
